// libs
import React from 'react';
import PropTypes from 'prop-types';

// component
import SearchTag from './SearchTag';

function SearchTags(props, { t }) {
  const {
    filterLabels,
    formValues,
    selectArtist,
    resetSearch,
    updateFormValues,
    updateSelectArtist,
  } = props;
  const valuesKey = Object.keys(formValues).filter((key) => formValues[key] !== '' && formValues[key] !== false && key !== 'filterCategory' && key !== 'keywords');
  return (
    <section className="filters__active-filters">
      <ul className="filters__active-filters__list">
        { valuesKey.map((key) =>
          <SearchTag
            key={key}
            tag={key}
            updateFormValues={updateFormValues}
            filterLabels={filterLabels}
            formValues={formValues}
          />,
        )}
        { selectArtist.map((artist) =>
          <li className="filters__active-filters__item" key={`tag-${artist}`}>
            {artist}
            <button
              className="filters__active-filters__button"
              type="button"
              onClick={() => {
                const indexToRemove = selectArtist.indexOf(artist);
                const newSelectArtist = selectArtist.splice(indexToRemove, 1);
                updateSelectArtist(selectArtist.splice(newSelectArtist, 1));
              }}
            />
          </li>,
        )}
      </ul>
      {(valuesKey.length > 0 || selectArtist.length > 0) &&
        <button
          className="filters__active-filters__reset link link--tool"
          onClick={() => {
            resetSearch();
            updateSelectArtist([]);
          }}
        >
          {t('search.resetSearch')}
        </button> }
    </section>
  );
}

SearchTags.contextTypes = {
  t: PropTypes.func,
};

SearchTags.propTypes = {
  filterLabels: PropTypes.array.isRequired,
  formValues: PropTypes.object.isRequired,
  resetSearch: PropTypes.func.isRequired,
  selectArtist: PropTypes.array.isRequired,
  updateFormValues: PropTypes.func.isRequired,
  updateSelectArtist: PropTypes.func.isRequired,
};

export default SearchTags;



// WEBPACK FOOTER //
// ./src/app/components/pages/search/form/parts/SearchTags.js